import React from 'react';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';


const KBCategory = ({
  goToPage,
  activeCategory,
  categories,
  chooseCategory,
  hasMore,
}) => (
  <ul
    className="kb2tabs fontmulisemi forscrolltc forscroll2 kb-cat"
  >
    <InfiniteScroll
      loadMore={goToPage}
      hasMore={hasMore}
      pageStart={0}
      useWindow={false}
      initialLoad={false}
      loader={<div className="loader" key={0}>Loading ...</div>}
    >
      {categories.map(category => (
        <li key={category.id}>
          <a
            className={activeCategory && activeCategory.id === category.id ? 'kblink active' : 'kblink'}
            href="#"
            onClick={e => chooseCategory(e, category)}
          >{category.title}
          </a>
        </li>
      ))}
    </InfiniteScroll>
  </ul>
);

KBCategory.propTypes = {
  categories: PropTypes.array.isRequired,
  chooseCategory: PropTypes.func.isRequired,
};

export default KBCategory;



// WEBPACK FOOTER //
// ./src/views/modules/kb/kbCategoryList/KBCategory.jsx